export interface UserPreferenceOptionsResponse {
	options: string[];
}

export enum UserPreferenceKey {
	LandingPage = 'landing_page',
	DashboardFilter = 'dashboard-filter',
	DashboardView = 'dashboard-view',
}
